<div class="d-flex flex-column schema-builder-container overflow-auto">
  <div *ngIf="schemaFormatUnsupported" class="schema-format-unsupported-banner alert alert-warning mx-3 mt-3 mb-0" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    The provided schema cannot be shown in this view. You can edit it in the JSON view.
  </div>
  <style>
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .spin {
      animation: spin 1s linear infinite;
      display: inline-block;
    }
  </style>
  <form [formGroup]="schemaForm" class="d-flex flex-column flex-grow-1 px-3 pt-3">
    <!-- Fixed Header Section -->
    <div class="container-fluid p-0">
      <!-- Template Controls Bar -->
      <div class="template-controls d-flex align-items-center justify-content-between gap-2 mb-2">
        <div class="d-flex align-items-center gap-2">
        <div class="dropdown d-inline-block" ngbDropdown [autoClose]="'outside'" #templateDropdown="ngbDropdown">
          <button class="schema-control-button schema-dropdown-button d-flex align-items-center justify-content-between" ngbDropdownToggle>
            <span class="text-truncate">
              {{ getSelectedOptionText() || 'Select a template ...' }}
            </span>
          </button>
          <div class="dropdown-menu shadow" ngbDropdownMenu style="max-height: 300px; overflow-y: auto;">
            <h6 class="dropdown-header" *ngIf="availableSchemas.length > 0">Available Templates</h6>
            <div class="dropdown-item d-flex align-items-center justify-content-between"
                 *ngFor="let schema of availableSchemas"
                 style="cursor: pointer;">
              <!-- Template name display/edit -->
              <span class="text-truncate me-3 flex-grow-1"
                    *ngIf="editingTemplateId !== schema.schema_id"
                    (click)="onTemplateSelect(schema.schema_id)">
                {{schema.schema_name}}
              </span>
              <input class="form-control form-control-sm me-3 flex-grow-1"
                     *ngIf="editingTemplateId === schema.schema_id"
                     type="text"
                     [value]="editingTemplateName"
                     [attr.data-template-id]="schema.schema_id"
                     (keydown)="onTemplateNameKeydown($event, schema.schema_id)"
                     (blur)="onTemplateNameBlur($event, schema.schema_id)"
                     (click)="$event.stopPropagation()"
                     (input)="onTemplateNameInput($event)"
                     placeholder="Enter template name">

              <!-- Action buttons -->
              <div class="d-flex gap-1">
                <button class="btn btn-sm btn-link text-primary p-0"
                        *ngIf="editingTemplateId !== schema.schema_id"
                        (click)="editTemplate(schema.schema_id, $event)"
                        title="Edit template name">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn btn-sm btn-link text-success p-0"
                        *ngIf="editingTemplateId === schema.schema_id"
                        (click)="saveTemplateEdit(schema.schema_id, editingTemplateName)"
                        title="Save changes">
                  <i class="bi bi-check"></i>
                </button>
                <button class="btn btn-sm btn-link text-secondary p-0"
                        *ngIf="editingTemplateId === schema.schema_id"
                        (click)="cancelTemplateEdit()"
                        title="Cancel editing">
                  <i class="bi bi-x"></i>
                </button>
                <button class="btn btn-sm btn-link text-danger p-0"
                        *ngIf="editingTemplateId !== schema.schema_id"
                        (click)="deleteSchema(schema.schema_id, $event)"
                        title="Delete template">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
            <div class="dropdown-item" *ngIf="availableSchemas.length === 0">
              <span class="text-muted">No templates available</span>
            </div>
          </div>
        </div>
        <button type="button" class="schema-control-button" (click)="saveTemplate()">
          <i class="bi bi-floppy"></i>
          <span class="full-text">Save Template</span>
          <span class="short-text" title="Save Template">Save</span>
        </button>
        <button type="button" class="schema-control-button" (click)="confirmReset(resetModal)">
          <i class="bi bi-arrow-counterclockwise"></i> 
            <span class="full-text">Clear Template</span>
            <span class="short-text" title="Clear Template">Clear</span>
        </button>
        </div>
        <!-- Hide QA Info Button for now till the BE is ready-->
        <!-- <app-document-qa-info
          *ngIf="tableId"
          [tableId]="tableId"
          [active]="true"
          [disabled]="shellLoading"
          [isSchemaView]="true"
        ></app-document-qa-info> -->
      </div>

      <div formArrayName="sheets">
        <!-- Tabs Navigation with fixed width for buttons -->
        <div id="template-top-bar" class="position-relative">
          <!-- Scrollable tabs container -->
          <div id="template-sheets-list" class="flex-grow-1">
            <div class="d-flex align-items-flex-start pt-1">
              <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs flex-nowrap me-1">
                <li *ngFor="let sheet of sheets.controls; let i=index" [ngbNavItem]="i">
                  <div class="me-2" ngbDropdown [placement]="'bottom-start'" [autoClose]="true" container="body">
                    <a ngbNavLink class="schema-sheet-button"
                       id="sheetButton_{{ i }}"
                       [class.active]="activeTab === i"
                       (click)="$event.stopPropagation()">
                      <span *ngIf="!sheet.get('isSheetNameEdit')?.value"
                             class="text-truncate d-block py-1 px-2"
                             [title]="sheet.get('name')?.value || 'Sheet ' + (i + 1)">
                        {{sheet.get('name')?.value || 'Sheet ' + (i + 1)}}
                      </span>
                      <input class="sheet-name-input"
                             *ngIf="sheet.get('isSheetNameEdit')?.value"
                             type="text"
                             [value]="sheet.get('name')?.value"
                             (input)="updateSheetName($event, sheet)"
                             (keydown.enter)="$event.preventDefault(); stopEditingSheet(sheet)"
                             (focusout)="stopEditingSheet(sheet)"
                             (click)="$event.stopPropagation(); $event.preventDefault()"
                             #sheetNameInput />
                    </a>
                    <button class="dropdown-toggle-split position-absolute end-0 top-0 h-100 border-0 bg-transparent"
                            style="width: 28px;"
                            ngbDropdownToggle
                            type="button"
                            (click)="$event.stopPropagation(); $event.preventDefault()">
                    </button>
                    <!-- Dropdown menu -->
                    <div class="dropdown-menu shadow-sm" ngbDropdownMenu style="z-index: 1050;">
                      <button type="button" class="dropdown-item" (click)="editSheetName(sheet)">
                        <i class="bi bi-pencil me-2"></i>Rename sheet
                      </button>
                      <button type="button" class="dropdown-item text-danger" (click)="removeSheet(i)">
                        <i class="bi bi-trash me-2"></i>Delete sheet
                      </button>
                    </div>
                  </div>
                  <ng-template ngbNavContent>
                    <div [formGroupName]="i">
                      <div [formArrayName]="'properties'" class="mb-3">

                        <!-- Column Cards -->
                        <div class="column-cards overflow-auto mb-1" >
                            <div cdkDropList
                                 [cdkDropListDisabled]="!isDragDropEnabled"
                                 (cdkDropListDropped)="onColumnDrop($event, i)"
                                 [cdkDropListData]="safeGetSheetProperties(i).controls">
                              <div *ngFor="let prop of safeGetSheetProperties(i).controls; let j=index"
                                   class="card mb-3 schema-card"
                                   [formGroupName]="j"
                                   cdkDrag
                                   [cdkDragDisabled]="!isDragDropEnabled"
                                   [class.drag-disabled]="!isDragDropEnabled"
                                   (cdkDragStarted)="onDragStarted()"
                                   (cdkDragEnded)="onDragEnded()"
                                   (cdkDragMoved)="onDragMoved($event)">
                                <div class="card-body" (click)="toggleColumnEdit(i, j)">
                                  <div class="d-flex align-items-center gap-3">
                                    <!-- Drag Handle -->
                                    <div class="drag-handle"
                                         cdkDragHandle
                                         [class.disabled]="!isDragDropEnabled"
                                         *ngIf="isDragDropEnabled">
                                      <i class="bi bi-grip-vertical text-muted"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                      <div class="d-flex justify-content-between">
                                        <div class="mb-2 fw-bold field-name">{{prop.get('name')?.value}}</div>
                                        <div class="d-flex gap-2 align-items-center">
                                          <button type="button" class="edit" (click)="toggleColumnEdit(i, j)"
                                                  [disabled]="prop.invalid">
                                            <img src="../../../assets/img/icons/edit.svg" alt="Edit" />
                                          </button>
                                          <button type="button" class="delete" (click)="$event.stopPropagation(); removeSheetProperty(i, j)">
                                            <img src="../../../assets/img/icons/delete.svg" alt="Delete" />
                                          </button>
                                          <span [ngClass]="['tag', 'tag-' + (prop.get('presence')?.value || 'common')]">
                                            {{ prop.get('presence')?.value || 'common' }}
                                          </span>
                                        </div>
                                      </div>
                                      <p class="text-muted mb-1 field-description" *ngIf="prop.get('description')?.value">
                                        {{prop.get('description')?.value}}
                                      </p>
                                      <div class="d-flex justify-content-between align-items-center mt-3">
                                        <div *ngIf="prop.get('options')?.value?.length; else exampleValue">
                                          <span class="fw-bold me-2 field-example-label">OPTIONS:</span>
                                          <small class="field-example-value" *ngIf="prop.get('options')?.value?.length">
                                            {{ prop.get('options')?.value?.join(', ') }}
                                          </small>
                                        </div>
                                        <ng-template #exampleValue>
                                          <div>
                                            <span class="fw-bold me-2 field-example-label">EXAMPLE:</span>
                                          <small class="field-example-value" *ngIf="prop.get('example')?.value">
                                            {{prop.get('example')?.value}}
                                          </small>
                                          </div>
                                        </ng-template>
                                        <span [ngClass]="['tag', 'tag-type', 'tag-' + ((prop.get('options')?.value?.length ? 'enum' : (prop.get('type')?.value || 'string')))]">
                                          {{ prop.get('options')?.value?.length ? 'enum' : (prop.get('type')?.value || 'string') }}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        <div class="d-flex justify-content-center mb-3 mt-4 add-field-button-container">
                          <button type="button" 
                                  class="add-field-button" 
                                  (click)="openCardEditModal(sheets.at(activeTab))" >
                            <span class="plus">+ </span>
                            <span>Add Field</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
              </ul>
              <button type="button" class="schema-sheet-button p-1" (click)="addSheet()">
                <i class="bi bi-plus-lg"></i>
              </button>
            </div>
          </div>
          <div class="template-top-bar-toggle d-flex align-items-center pt-1 ps-2" title="Allow multiple rows">
            <label class="switch m-0">
              <input type="checkbox"
                     [checked]="getCurrentSheetMultipleRows()"
                     (change)="onMultipleRowsToggle($event)" />
              <span class="slider round"></span>
            </label>
          </div>
          <!-- Action Buttons - Fixed -->
          <!-- <div id="template-buttons"> -->
            <!-- Auto-save indicator -->
             <!--
            <div class="d-flex align-items-center ms-2 text-muted">
              <small *ngIf="!isSaving && isFormValid"><i class="bi bi-check-circle me-1"></i> Auto-saved</small>
              <small *ngIf="isSaving && isFormValid"><i class="bi bi-arrow-repeat me-1 spin"></i> Saving...</small>
              <small *ngIf="!isFormValid"><i class="bi bi-exclamation-triangle me-1"></i> Incomplete</small>
            </div>
            -->
          <!-- </div> -->
        </div>

        <div class="ai-hint-container my-2">
          <div class="d-flex align-items-center gap-2 p-2" *ngIf="!showTextInputForAI" (click)="showTextInputForAI = true">
            <img src="../../../assets/img/icons/ai-sparkles.svg" alt="AI" class="ai-hint-icon" />
            <span class="ai-hint-text">Ask AI to modify structure...</span>
          </div>
          <div class="prompt-box" *ngIf="showTextInputForAI">
            <div class="input-row">
              <img src="../../../assets/img/icons/ai-sparkles.svg" alt="AI" class="ai-hint-icon" />
              <textarea placeholder="Describe changes..." [formControl]="promptControl"></textarea>
            </div>
          
            <div class="actions">
              <button class="simple-button" (click)="showTextInputForAI = false">Cancel</button>
              <button class="purple-button" (click)="sendPromptToAI()">Generate</button>
            </div>
          </div>
        </div>

        <div class="mismatch-container" *ngIf="hasSchemaChanged && hasStructuredFiles">
          <div class="mismatch-title">
            <span class="mismatch-circle"></span>
            <span>SCHEMA MISMATCH</span>
          </div>
          <div class="mismatch-text mt-2">Schema definitions differ from extracted data.</div>
          <button type="button" class="mismatch-action mt-2">
            <i class="bi bi-arrow-repeat"></i>
            <span>Resolve &amp; Apply</span>
          </button>
        </div>

        <!-- Scrollable Content Area -->
        <div cdkScrollable #scrollableContainer>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
      </div>
    </div>
  </form>

  <!-- Toast Notification -->
  <div class="toast-container position-fixed top-0 end-0 p-3">
    <ngb-toast
      *ngIf="showToast"
      [autohide]="true"
      [delay]="3000"
      (hidden)="showToast = false"
      [class.bg-success]="toastType === 'success'"
      [class.bg-danger]="toastType === 'error'"
      class="text-white">
      <div class="d-flex align-items-center">
        <i [class.bi-check-circle-fill]="toastType === 'success'"
           [class.bi-exclamation-circle-fill]="toastType === 'error'"
           class="bi me-2"></i>
        <div>
          <strong>{{toastType === 'success' ? 'Success!' : 'Error'}}</strong><br>
          {{toastMessage}}
        </div>
      </div>
    </ngb-toast>
  </div>
</div>

<!-- Reset Confirmation Modal -->
<ng-template #resetModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Reset Template</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to reset the template? This will clear all sheets and columns.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="modal.close('reset')">Reset</button>
  </div>
</ng-template>

<!-- Save Template Modal -->
<ng-template #saveTemplateModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Save Template</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="saveTemplateForm">
      <div class="mb-3">
        <label for="templateName" class="form-label">Template Name</label>
        <input type="text" class="form-control" id="templateName" formControlName="name" placeholder="Enter template name">
        <div class="invalid-feedback" *ngIf="saveTemplateForm.get('name')?.invalid && saveTemplateForm.get('name')?.touched">
          Template name is required
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="saveTemplateForm.invalid" (click)="modal.close(saveTemplateForm.value)">Save</button>
  </div>
</ng-template>

<!-- Delete Confirmation Modal -->
<ng-template #deleteConfirmModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>
    <div class="modal-body">
      <div class="icon-stack">
        <div class="icon-main">
          <img
            src="../../../assets/img/icons/table-custom.svg"
            alt="Table icon"
          />
          <span class="icon-status" aria-hidden="true">
            <svg
              class="trash-svg"
              width="12"
              height="13.5"
              viewBox="0 0 12 13.5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 3.5h9M4.5 3.5v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1M10 3.5l-.6 7.2a1 1 0 0 1-1 .8H3.6a1 1 0 0 1-1-.8L2 3.5M5 6v4M7 6v4"
                stroke="#FFFFFF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
        <div>
          <h4 class="confirm-title">
            Are you sure you want to delete this {{ deleteType.toLowerCase() }}?
          </h4>
          <p class="confirm-subtext">
            "{{ deleteItemName }}" will be permanently removed. This action cannot be undone.
          </p>
        </div>
      </div>
      <div class="button-group">
        <button
          class="btn cancel-btn text-decoration-none"
          (click)="modal.dismiss()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn delete-btn"
          (click)="modal.close('delete')"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>
